import { AuthXInterceptor } from '../Config/AuthXInterceptor'

export interface StationLookupOption {
  id: string
  businessName: string
  branchName: string
}

export const stationLookupBXService = {
  search: async (search: string) => {
    const response = await AuthXInterceptor.get<{ data: StationLookupOption[] }>(
      '/station-attendants/filling-stations',
      { params: search ? { search } : {} },
    )
    return response.data.data
  },
}
